window.mmCart = {
  RenderCart: function() { 
    $.get('/cart?view=mm-ajax', function(cart) {
      
      //Replace html
      $('#CartHolder').html(cart);
      
      //Update Count
      $.getJSON('/cart.js', function(new_cart) {
        var CartCount = new_cart.item_count;        
        $('.header__cart-count').html(CartCount);
      })
      
      //Activate action buttons
      $('.quantity-selector, [name="checkout"]').removeClass('is-disabled');
    })    
  },
  
  CartChangeHandler: function(data) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      type: 'post',
      data: data,
      success: function(cart) {               
        mmCart.OfferHandler(cart);
      },
      error: function(jqXHR, textStatus, errorThrown) {
        if(jqXHR.status == 422) {
          alert(jqXHR.responseJSON.description);
          mmCart.RenderCart();
        }
      }
    });
  },
  
  CartQuantityHandler: function() {
    $(document).on('click', '.quantity-selector .plus', function(evt) {
      evt.preventDefault();
   
      let q = $(this).parent().find('.quantity-selector__input').val(),
          i = 1,
          p = parseInt(i),
          u = parseInt(q) + p;
      $(this).parent().find('.quantity-selector__input').val(u).trigger('change');
      
      return false;
    })
    $(document).on('click', '.quantity-selector .minus', function(evt) {
      evt.preventDefault();

      let q = $(this).parent().find('.quantity-selector__input').val(),
          i = 1,
          p = parseInt(i),
          u = parseInt(q) - p;
      $(this).parent().find('.quantity-selector__input').val(u).trigger('change');
    })
    $(document).on('change', '.quantity-selector__input', function() {
      var UpdatedQuantity = parseInt($(this).val()),
          QuantityKey = $(this).attr('data-line-key'),
          params = {
            quantity: UpdatedQuantity,
            id: QuantityKey
          };
            
      //Disable action buttons
      $('.quantity-selector, [name="checkout"]').addClass('is-disabled');
      
      //Call change handler
      mmCart.CartChangeHandler(params);
    })
    $(document).on('click', '.line-item__quantity-remove', function(evt) {
      evt.preventDefault();

      var RemoveKey = $(this).attr('data-line-key'),
          params = {
            quantity: 0,
            id: RemoveKey
          };
      mmCart.CartChangeHandler(params);
    })
  },
  
  OfferHandler: function() {     
    $.get('/cart?view=json', function(custom_cart) {
      var cart = JSON.parse(custom_cart)[0];
   
      var renderCart = true;
      var CartPrice = cart.cart_total; 
    
      /*========================================================================
        ::PRICE OFFERS::
      ========================================================================*/
      var PriceOfferData = JSON.parse($('#CartHolder').attr('data-price-offer'));        
      var OfferPrice1 = parseInt(PriceOfferData.OfferPrice1);
      var OfferPrice2 = parseInt(PriceOfferData.OfferPrice2);
      var OfferPrice3 = parseInt(PriceOfferData.OfferPrice3);

      var PriceOfferAddItems = [];
      var PriceOfferRemoveItems = [];

      var PriceSlab3Added = false;
      var PriceSlab2Added = false;
      var PriceSlab1Added = false;

      for(var i=0; i < cart.items.length; i++){      
        var VariantId = cart.items[i].variant_id;

        //Check offer properties
        //To see if the offer product is already exists on cart or not
        if(cart.items[i].properties) {
          var offerProperty = cart.items[i].properties._Offer;

          if (offerProperty) {
            if (offerProperty == 'priceSlab3') {
              PriceSlab3Added = true;
            }
            if (offerProperty == 'priceSlab2') {
              PriceSlab2Added = true;
            }
            if (offerProperty == 'priceSlab1') {
              PriceSlab1Added = true;
            }
          }
        }      
      }

      /*--------------------------------------------------------------------------------
       *	Get the array of variants to be added::
       *	Conditions: 
       *	 - If offer is enabled
       *   - If cart price is more than offer price
       *   - If product is not already added
       *   - If product variants are not blank 

       - if offer3 enabled && cart price > OfferPrice3
       - if offer2 enabled && cart price > OfferPrice2
       --------------------------------------------------------------------------------*/    
      //1499
      if(PriceOfferData.Offer3 && CartPrice >= OfferPrice3 && PriceSlab3Added == false && PriceOfferData.OfferVariants3 != '') {
        var OfferVariants = PriceOfferData.OfferVariants3.split(',');

        $.each(OfferVariants, function(i, v) {
          PriceOfferAddItems.push({
            id: parseInt(v), 
            quantity: 1, 
            properties: {
              '_Offer': 'priceSlab3'
            }
          });
        })
      }
      //999
      else if(PriceOfferData.Offer2 && CartPrice >= OfferPrice2 && PriceSlab2Added == false && PriceOfferData.OfferVariants2 != '') {      
        if((PriceOfferData.Offer3 && CartPrice >= OfferPrice3 && PriceSlab3Added)) {
          //Don't add
        } else {
          var OfferVariants = PriceOfferData.OfferVariants2.split(',');

          $.each(OfferVariants, function(i, v) {
            PriceOfferAddItems.push({id: parseInt(v), quantity: 1, properties: {'_Offer': 'priceSlab2'}});
          })   
        }
      }
      //799
      else if(PriceOfferData.Offer1 && CartPrice >= OfferPrice1 && PriceSlab1Added == false && PriceOfferData.OfferVariants1 != '') {
        if((PriceOfferData.Offer3 && CartPrice >= OfferPrice3 && PriceSlab3Added) || (PriceOfferData.Offer2 && CartPrice >= OfferPrice2 && PriceSlab2Added)) {
          //Don't add
        } else {
          var OfferVariants = PriceOfferData.OfferVariants1.split(',');

          $.each(OfferVariants, function(i, v) {
            PriceOfferAddItems.push({id: parseInt(v), quantity: 1, properties: {'_Offer': 'priceSlab1'}});
          }) 
        }               
      }
           
      /*--------------------------------------------------------------------------------
       *	Get the array of variants to be removed::
       *	Conditions: 
       *   - If cart price is less than offer price
       *   - If product is added to cart  

       * 	Special cases: 
       *	 - Offer(1) and Offer(2) --> Check the upper price limit also
       --------------------------------------------------------------------------------*/ 
      var Offer3Variants = PriceOfferData.OfferVariants3.split(',');
      var Offer2Variants = PriceOfferData.OfferVariants2.split(',');
      var Offer1Variants = PriceOfferData.OfferVariants1.split(',');

      if(PriceSlab3Added && CartPrice < OfferPrice3) {
        $.each(Offer3Variants, function(i, v) {
          PriceOfferRemoveItems.push(cart.items[i].key);
        })
      }
      if(PriceSlab2Added) {
        //if CartPrice < OfferPrice2
        //else if PriceOfferData.Offer3 && CartPrice >= OfferPrice3
        $.each(Offer3Variants, function(i, v) {
          if(CartPrice < OfferPrice2) {
            PriceOfferRemoveItems.push(cart.items[i].key);
          }
          else if(PriceOfferData.Offer3 && CartPrice >= OfferPrice3) {
            PriceOfferRemoveItems.push(cart.items[i].key);
          }
        })
      }
      if(PriceSlab1Added) {      
        //if CartPrice < OfferPrice1
        //else if PriceOfferData.Offer3 && CartPrice >= OfferPrice3
        //else if PriceOfferData.Offer2 && CartPrice >= OfferPrice2
        $.each(Offer1Variants, function(i, v) {
          if(CartPrice < OfferPrice1) {
            PriceOfferRemoveItems.push(cart.items[i].key);
          }
          else if(PriceOfferData.Offer2 && CartPrice >= OfferPrice2) {
            PriceOfferRemoveItems.push(cart.items[i].key);
          }
          else if(PriceOfferData.Offer3 && CartPrice >= OfferPrice3) {
            PriceOfferRemoveItems.push(cart.items[i].key);
          }
        })
      }

      //Make the array unique
      PriceOfferAddItems = PriceOfferAddItems.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
      PriceOfferRemoveItems = PriceOfferRemoveItems.filter((v, i, a) => a.indexOf(v) === i);

      //If we have to do both add and remove call one by one
      if(PriceOfferAddItems.length && PriceOfferRemoveItems.length) {
        renderCart = false;
        mmCart.OfferRemoveHandler(PriceOfferRemoveItems, 0, true, PriceOfferAddItems);
      }
      else if(PriceOfferAddItems.length) {
        renderCart = false;
        mmCart.OfferAddHandler(PriceOfferAddItems);
      }
      else if(PriceOfferRemoveItems.length) {
        renderCart = false;
        mmCart.OfferRemoveHandler(PriceOfferRemoveItems, 0, false, null);
      }

      //This is a prevention to multi cart rendering
      //If there's any product to be added/removed we don't have the render cart
      if(renderCart) {
        mmCart.RenderCart();    
      }
    });
  },
    
  OfferAddHandler: function(productArray) {
    var AddParam = {
      items: productArray
    }
    
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: AddParam,
      success: function (item) {
        mmCart.RenderCart();
      }
    });
  },
  
  OfferRemoveHandler: function(productArray, quantity, sequence, add_items) {        
    var data = { updates: {} };    
    for (var i = 0; i < productArray.length; i++) {
      data.updates[productArray[i]] = quantity;
    }
    
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      type: 'post',      
      data: data,      
      success: function(cart) {
        if(sequence) {
          mmCart.OfferAddHandler(add_items);
        } else {
          mmCart.RenderCart();
        } 
      }
    });    
  }
};

$(document).ready(function() { 
  mmCart.CartQuantityHandler();  
  mmCart.OfferHandler();
});